module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"choose_signin":"Choose a sign in method:"},"zhHant":{"choose_signin":"選擇一種登入方式:"},"ja":{"choose_signin":"ログイン方法をお選びください"},"ko":{"choose_signin":"로그인 방식을 선택하십시오:"}}')
  delete Component.options._Ctor
}
